export interface ITwoStepApprovalSaveRequest {
    OrgId: number;
    TwoStepApproval: boolean;
    isReceiptTypeOn: boolean;
    isManualVatOn: boolean;
    isFmEditExpenseOn: boolean;
    isCostCentreOn: boolean;
    isCustomerOn: boolean;
    isPassengerLoadOn: boolean;
}

export class TwoStepApprovalSaveRequest implements ITwoStepApprovalSaveRequest {
    OrgId: number;
    TwoStepApproval: boolean;
    isReceiptTypeOn: boolean;
    isManualVatOn: boolean;
    isFmEditExpenseOn: boolean;
    isCostCentreOn: boolean;
    isCustomerOn: boolean;
    isPassengerLoadOn: boolean;
}

export interface ITwoStepApprovalSaveResponse {
    responseString: string;
}

export class TwoStepApprovalSaveResponse implements ITwoStepApprovalSaveResponse {
    responseString: string;
}
export class GetOrgPreferencesRequest {
    orgId: number;
    userId: number;
    requisitionRuleType: number;
    requisitionApprovalRuleType: number;
    isRequisitionApprovalRuleType: boolean;

    //log fields
    oldRequisitionApprovalRuleType: number;
    oldRequisitionRuleType: number;
}

